import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var ChecklistSVG = function ChecklistSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26 2H6a2 2 0 00-2 2v24a2 2 0 002 2h20a2 2 0 002-2V4a2 2 0 00-2-2zM13 25h-2a1 1 0 010-2h2a1 1 0 010 2zm1.73-8.83l-2.86 3a.87.87 0 01-1.3 0l-1.3-1.38a1 1 0 010-1.38.88.88 0 011.3 0l.65.69 2.21-2.36a.9.9 0 011.3 0 1 1 0 010 1.43zm0-7l-2.86 3a.87.87 0 01-1.3 0l-1.3-1.38a1 1 0 010-1.38.88.88 0 011.3 0l.65.69 2.21-2.36a.9.9 0 011.3 0 1 1 0 010 1.43zM22 25h-4a1 1 0 010-2h4a1 1 0 010 2zm0-6h-4a1 1 0 010-2h4a1 1 0 010 2zm0-7h-4a1 1 0 010-2h4a1 1 0 010 2z"
  }));
};
ChecklistSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ChecklistSVG);